<template>
    <form
        class="form-horizontal"
        enctype="multipart/form-data"
        autocomplete="off"
    >
        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.invoice_number') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="number"
                    :required="true"
                >
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.invoice_date') }}</label>
            <div class="col-md-9 col-sm-12">
                <vue-pikaday
                    v-model="sent_at"
                    :options="options"
                    :required="true"
                    class="form-control"
                    autocomplete="off"
                />
            </div>
        </div>

        <input
            :disabled="working"
            type="button"
            @click.prevent="updateInvoice"
            class="btn btn-brand"
            :value="uLang('app.save')"
        />
    </form>
</template>

<script>
    import { SuccessAlert } from "~/Swals"
    import { PikadayOptions} from "~/Form/elements";

    export default {
        name: 'EditCreditInvoiceForm',

        props: {
            invoiceId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                number: '',
                sent_at: null,
                entity: 'credit_invoice',
                invoice: null,
                working: false,
                options: PikadayOptions,
            }
        },

        watch: {
            invoiceId: {
                immediate: true,
                handler: async function(invoiceId) {
                    const { data } = await window.axios.get(route('invoices.credit.show', { invoice: this.invoiceId }));

                    this.invoice = data
                },
            },
        },

        methods: {
            async updateInvoice() {
                this.working = true;

                const response = await window.axios.put(route('invoices.credit.received', { invoice: this.invoiceId }), {
                    number: this.number,
                    sent_at: this.sent_at,
                });

                this.number = ''
                this.sent_at = null
                this.working = false

                this.$emit('close');

                if(response.status === 200) {
                    return new SuccessAlert({ text: this.uLang('app.type_successfully_updated', {type: lang('app.credit_invoice')})}).show();
                }

                return new ErrorAlert({ text: this.uLang('app.try_again_later')}).show();
            }
        },
    }
</script>

<style lang="scss" scoped>
.btn {
    font-size: 11px;
}

.fa-stack {
    font-size: 11px;
}

.fa-backward::before {
    margin-left: -5px;
}
</style>
